<template>
  <div v-if="location">
    <b-row>
      <!-- Cargamos el mapa-->
      <b-col cols="4">
        <p>Ubicación geográfica</p>
        <div>
          <vue-layers
            style="height: 300px"
            :zoom=14
            class="mapa"
            :key="selectedTab"
            :longitude="parseFloat(location.location.longitude)"
            :latitude="parseFloat(location.location.latitude)"
            :nodesCoordinates="coordenada"
          />
        </div>
      </b-col>

      <!-- Cargamos los datos -->
      <b-col>
        <location-details
          :location="location"
          @updated="refreshLocationData"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
//import GoogleMap from "@/components/maps/GoogleMap";
import Spacer from "@/components/card/Spacer";
import VueLayers from "@/components/maps/VueLayers";
import LocationDetails from "./LocationDetails";

export default {
  props: ["location", "selectedTab"],
  watch: {
    //Hack the :key y watch para saber en qué tabs estamos y forzar
    //el refresco del mapa de forma reactiva
    selectedTab: function (newVal, oldVal) {
      return newVal;
    },
  },
  computed: {
    coordenada: function() {
      let array = [];
      let coordinatePair = {
        latitud: parseFloat(this.location.location.longitude),
        longitud: parseFloat(this.location.location.latitude),
        alias: this.location.alias,
      };
      array.push(coordinatePair)

      return array;
    },
  },
  data() {
    return {};
  },
  mounted() {},
  components: {
    VueLayers,
    "spacer-card": Spacer,
    "location-details": LocationDetails,
  },
  methods: {
    locationDeleted(id) {
      this.$emit("locationdeleted", id);
    },

    refreshLocationData(location) {
      this.$refs.devicesDetails.selectedLocation = location.alias;
    },

    editCancelled() {
      this.$emit("editcancelled");
    },
  },
};
</script>


<style scoped>
.mapa {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 5px;
}
</style>